/** 站内导航结构。顶部导航、移动端抽屉与页脚统一从这里取。 */

import { SITE } from './site';

export interface NavLink {
  to: string;
  label: string;
  /** 站外链接（GitHub），渲染成 `<a target="_blank">`。 */
  external?: boolean;
}

export interface FooterGroup {
  title: string;
  links: readonly NavLink[];
}

/** 顶部主导航（「联系我们」作为右侧按钮单独呈现，不在这里）。 */
export const PRIMARY_NAV: readonly NavLink[] = [
  { to: '/products', label: '产品' },
  { to: '/solutions', label: '解决方案' },
  { to: '/pricing', label: '方案与定价' },
  { to: '/news', label: '动态' },
  { to: '/articles', label: '技术文章' },
  { to: '/about', label: '关于我们' },
];

/*
 * 页脚分五列。层级按访客找东西的顺序排：先看有什么产品，再看能解决什么，
 * 然后是能自助拿到的资料，最后才是公司与法务。
 */
export const FOOTER_GROUPS: readonly FooterGroup[] = [
  {
    title: '产品',
    links: [
      { to: '/products', label: '产品目录' },
      { to: '/platform', label: '平台能力' },
      { to: '/platform#realtime', label: '实时链路' },
      { to: '/platform#access', label: '接入协议' },
      { to: '/products#coming-soon', label: '即将上线' },
    ],
  },
  {
    title: '解决方案',
    links: [
      { to: '/solutions', label: '全部场景' },
      { to: '/solutions#park', label: '园区与起降场' },
      { to: '/solutions#inspection', label: '巡检作业队' },
      { to: '/solutions#diy', label: '个人开发者接入' },
      { to: '/solutions#enterprise', label: '企业定制' },
    ],
  },
  {
    title: '资源与支持',
    links: [
      { to: SITE.consoleUrl, label: '控制台', external: true },
      { to: '/pricing', label: '方案与定价' },
      { to: '/pricing#trial', label: '申请试用' },
      { to: '/platform#faq', label: '常见问题' },
      { to: '/agents', label: 'Agent 接入' },
      { to: '/news', label: '工程动态' },
      { to: '/articles', label: '技术文章' },
      { to: '/contact', label: '联系我们' },
    ],
  },
  {
    title: '公司',
    links: [
      { to: '/about', label: '关于我们' },
      { to: '/about#brand', label: '商标说明' },
      { to: 'https://github.com/Havorix-Aero', label: 'GitHub', external: true },
    ],
  },
  {
    title: '法务',
    links: [
      { to: '/privacy', label: '隐私政策' },
      { to: '/terms', label: '使用条款' },
    ],
  },
];

/** 页脚顶部的一句话导航（移动端与窄屏更常用）。 */
export const FOOTER_INLINE: readonly NavLink[] = [
  { to: '/products', label: '产品' },
  { to: '/solutions', label: '解决方案' },
  { to: '/pricing', label: '方案与定价' },
  { to: '/news', label: '动态' },
  { to: '/about', label: '关于我们' },
  { to: '/contact', label: '联系我们' },
];

/**
 * 「控制台」入口。
 *
 * 顶部导航在窄屏放不下，因此桌面端只在 xl 以上显示，其余宽度统一走移动端抽屉与页脚。
 * 控制台是全站唯一的登录入口，所以它始终是一个跳转，而不是一个需要登录才能点的按钮。
 */
export const CONSOLE_LINK: NavLink = { to: SITE.consoleUrl, label: '控制台', external: true };
